export const benefitInfoNoServiceType = 'No Service Type';
